export default "__VITE_ASSET__9389c7c5__"